import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { clearUpdateStatus, fetchRolesApiThunk, updateRolesApiThunk } from './rolesSlice';
import { RootState } from '..';
import {
  CreateRoleRequest,
  ListBuRolesRequest,
  UpdateRoleRequest,
} from 'src/types/orbit/Roles';

export const useRoles = () => {
  const dispatch = useAppDispatch();
  const roles = useAppSelector((state: RootState) => state.roles.rolesList);
  const fetchRolesApiStatus = useAppSelector(
    (state: RootState) => state.roles.fetchRolesApiStatus,
  );

  const updateRolesApiStatus = useAppSelector(
    (state: RootState) => state.roles.updateRolesApiStatus,
  );

  const loadRoles = useCallback(
    async (data: ListBuRolesRequest) => {
      dispatch(fetchRolesApiThunk(data));
    },
    [dispatch],
  );

  const updateRole = useCallback(
    async (data: UpdateRoleRequest) => {
      dispatch(updateRolesApiThunk({ data: data }));
    },
    [dispatch],
  );

  const clearUpdateStatusState = useCallback(() => {
    dispatch(clearUpdateStatus());
  }, [dispatch]);

  return {
    roles,
    updateRole,
    clearUpdateStatusState,
    fetchRolesApiStatus,
    updateRolesApiStatus,
    loadRoles,
  };
};
